import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export const PeriodicUsageAlert = () => {
    return (
        <Alert
            data-testid="PeriodicUsageAlert"
            severity="info"
            sx={{ marginBottom: '12px' }}
        >
            <AlertTitle>
                This monitor has a consumption type that is typically a periodic
                usage type. Our virtual monitor prediction algorithms may not
                produce accurate results. Consider installing a tank monitor on
                this tank for better results.
            </AlertTitle>
        </Alert>
    );
};
